export default __webpack_public_path__ + "9149f6fab193a46d15036fcd8b0a7c17.svg";